import React from "react";
import UnitsSelector from "../../../common/UnitsSelector";
import { NetworkAPI } from "apis";
import { MESSAGE } from "constants/Message";
import { inputClass, inputClassDisabled } from "helpers/StyleClass";

const targetingTitleClass = "block text-gray-800 font-bold mb-1"; //"font-semibold";

class CreateOrUpdateVirtualPlacement extends React.Component {
  constructor(props) {
    super(props);

    const { virtualPlacement } = props;
    const {
      virtualPlacementId = null,
      name = "",
      gamUnitIds = [],
    } = virtualPlacement || {};

    this.state = {
      isSaving: false,
      msg: [],

      virtualPlacement,

      virtualPlacementId,
      name,
      gamUnitIds,
    };

    this.handleUnitsChanged = this.handleUnitsChanged.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleUnitsChanged(unitIds) {
    this.setState({ gamUnitIds: unitIds });
  }

  async handleCreate() {
    this.setState({ isSaving: true, msg: [] });
    try {
      const { networkId } = this.props;
      const { name, gamUnitIds } = this.state;
      if (!name || name === "") throw new Error("Name is required");
      if (!gamUnitIds || gamUnitIds.length === 0) {
        throw new Error("At least one unitId is required");
      }

      const params = {
        name,
        gamUnitIds,
        networkId,
      };

      const r = await NetworkAPI.createNetworkVirtualPlacement(params);
      console.log(r);

      this.setState({
        isSaving: false,
        msg: ["Virtual Placement created!", MESSAGE.SUCCESS],
      });

      this.props.handleUpdate();
    } catch (err) {
      this.setState({
        msg: [`Failed to create virtual placement. ${err}`, MESSAGE.ERROR],
      });
    }

    this.setState({ isSaving: false });
  }

  async handleUpdate() {
    this.setState({ isSaving: true, msg: [] });
    try {
      const { networkId } = this.props;
      const { name, gamUnitIds, virtualPlacementId } = this.state;

      if (!name || name === "") throw new Error("Name is required");
      if (!gamUnitIds || gamUnitIds.length === 0) {
        throw new Error("At least one unitId is required");
      }

      const params = {
        virtualPlacementId,
        name,
        gamUnitIds,
        networkId,
      };

      const r = await NetworkAPI.updateNetworkVirtualPlacement(params);
      console.log(r);

      this.setState({
        isSaving: false,
        msg: ["Virtual Placement updated!", MESSAGE.SUCCESS],
      });

      this.props.handleUpdate();
    } catch (err) {
      this.setState({
        msg: [`Failed to update virtual placement. ${err}`, MESSAGE.ERROR],
      });
    }

    this.setState({ isSaving: false });
  }

  render() {
    const { networkId, formType } = this.props;
    const {
      virtualPlacement,
      virtualPlacementId,
      name,
      gamUnitIds,
      isSaving,
      msg,
    } = this.state;

    return (
      <>
        {virtualPlacement && (
          <div
            className="rounded border mb-4 overflow-y-auto bg-white px-4 pb-4 pt-2"
            style={{ maxHeight: "480px" }}
          >
            {virtualPlacementId && (
              <div className="mb-4">
                <label className="block font-bold text-gray-800" htmlFor="vpId">
                  ID
                </label>
                <input
                  className={inputClassDisabled}
                  id="vpId"
                  type="number"
                  defaultValue={virtualPlacementId}
                  disabled={true}
                />
              </div>
            )}

            <div className="mb-4">
              <label className="block font-bold text-gray-800" htmlFor="name">
                Name
              </label>
              <input
                className={inputClass}
                id="name"
                type="text"
                value={name}
                onChange={(e) => this.setState({ name: e.target.value })}
              />
            </div>

            <div className="pb-12">
              <div className={targetingTitleClass}>
                Unit IDs ({(gamUnitIds && gamUnitIds.length) || 0}):
                <div className="text-sm font-normal text-gray-700">
                  You can also paste a list of "," separated <i>unitIds</i> or{" "}
                  <i>extGamUnitIds</i>
                </div>
              </div>
              <UnitsSelector
                networkId={networkId}
                handleChanged={this.handleUnitsChanged}
                selectedItems={gamUnitIds}
                selectMetric="unitId"
                isCreatable={true}
              ></UnitsSelector>
            </div>
          </div>
        )}

        {msg && msg.length > 0 && (
          <div
            className={`px-2 py-1 font-semibold ${
              msg[1] === MESSAGE.ERROR
                ? "bg-red-100 text-red-500"
                : "bg-green-100 text-green-500"
            }`}
          >
            {msg[0]}
          </div>
        )}

        <div className="mt-4 flex flex-row-reverse items-center">
          {isSaving && <div className="loader"></div>}
          {msg.length > 0 && msg[1] === MESSAGE.SUCCESS && (
            <button
              type="button"
              className="rounded shadow bg-blue-500 px-4 py-2  font-semibold text-white hover:bg-blue-700"
              onClick={this.props.handleClose}
            >
              Close
            </button>
          )}
          {!isSaving && msg[1] !== MESSAGE.SUCCESS && (
            <>
              <button
                type="button"
                className="rounded shadow bg-blue-500 px-4 py-2  font-semibold text-white hover:bg-blue-700"
                onClick={
                  formType === "ADD" ? this.handleCreate : this.handleUpdate
                }
              >
                {formType === "ADD" ? "Create" : "Save edit"}
              </button>
              <button
                type="button"
                className="px-4 py-2 text-blue-700"
                onClick={this.props.handleClose}
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </>
    );
  }
}

export default CreateOrUpdateVirtualPlacement;
